/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-text-area[_ngcontent-%COMP%]     textarea{overflow:hidden;min-height:75px}"];
export { styles as styles };
